<template>
    <div>
        <div>
            <b-form ref="form" data-vv-scope="form-1">
              <legend><strong>Surat Permohonan</strong></legend>
              <b-row>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Nomor Surat Permohonan *">
                    <b-form-input disabled v-validate="'required'" name="Nomor Surat Permohonan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Surat Permohonan'),
                    }" v-model="dataPermohonan.nomor_surat_permohonan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Surat Permohonan')">
                      {{ errors.first("form-1.Nomor Surat Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Jenis Surat Permohonan *">
                    <b-form-input disabled v-validate="'required'" name="Jenis Surat Permohonan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Jenis Surat Permohonan'),
                    }" v-model="dataPermohonan.jenis_surat_permohonan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Surat Permohonan')">
                      {{ errors.first("form-1.Jenis Surat Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Tanggal Surat Permohonan: *">
                    <input
                      :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Surat Permohonan'), }"
                      type="date" v-validate="'required'" name="Tanggal Surat Permohonan"
                      v-model="dataPermohonan.tanggal_surat_permohonan" />
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Surat Permohonan')">
                      {{ errors.first("form-1.Tanggal Surat Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <legend><strong>Hasil Penilaian Teknis</strong></legend>
              <b-row>
                <div class="col-md-6">
                  <b-form-group label-for="Form" label ="Provinsi *">
                    <v-select disabled  id="default-select" v-model="dataPermohonan.provinsi"
                      :reduce="(provinsi) => provinsi.nama_provinsi" label="nama_provinsi" :options="dataProvinsi"
                      v-validate="'required'" name="Provinsi" :class="{ 'is-invalid': errors.has('form-1.Provinsi') }"
                      @input="getKabupaten(dataPermohonan.provinsi)" />
                    <span class="text-danger" v-if="errors.has('form-1.Provinsi')">
                      {{ errors.first("form-1.Provinsi") }}
                    </span>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label-for="Form" label ="Kabupaten">
                    <v-select disabled  id="default-select" v-model="dataPermohonan.kabupaten"
                      :reduce="(kabupaten) => kabupaten.nama_kabupaten" label="nama_kabupaten" :options="dataKabupaten"
                      name="Kabupaten" @input="getKecamatan(dataPermohonan.kabupaten)" />
                    <!-- <span class="text-danger" v-if="errors.has('form-1.Kabupaten')">
                                    {{ errors.first('form-1.Kabupaten') }}
                                </span> -->
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label-for="Form" label ="Kecamatan">
                    <v-select disabled  id="default-select" v-model="dataPermohonan.kecamatan"
                      :reduce="(kecamatan) => kecamatan.nama_kecamatan" label="nama_kecamatan"
                      :options="dataKecamatan" />
                    <!-- <span class="text-danger" v-if="errors.has('form-1.Kecamatan')">
                                    {{ errors.first('form-1.Kecamatan') }}
                                </span> -->
                  </b-form-group>
                </div>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Jenis Permohonan: *">
                    <v-select disabled  id="default-select" v-model="dataPermohonan.jenis_permohonan"
                      :reduce="(jenis) => jenis.nama" label="nama" :options="dataJenisPermohonan"
                      v-validate="'required'" name="Jenis Permohonan " :class="{
                        'is-invalid': errors.has('form-1.Jenis Permohonan'),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan')">
                      {{ errors.first("form-1.Jenis Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Klasifikasi Pemohon: *">
                    <v-select disabled  id="default-select" v-model="dataPermohonan.klasifikasi_pemohon"
                      :reduce="(klasifikasi) => klasifikasi.nama" label="nama" :options="dataKlasifikasi"
                      v-validate="'required'" name="Klasifikasi Pemohon" :class="{
                        'is-invalid': errors.has('form-1.Klasifikasi Pemohon'),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-1.Klasifikasi Pemohon')">
                      {{ errors.first("form-1.Klasifikasi Pemohon") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Nama Perairan *">
                    <b-form-input disabled v-validate="'required'" name="Nama Perairan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nama Perairan'),
                    }" v-model="dataPermohonan.nama_perairan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nama Perairan')">
                      {{ errors.first("form-1.Nama Perairan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label-for="Form" label ="Garis Pantai *">
                    <b-form-input disabled v-validate="'required'" name="Garis Pantai" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Garis Pantai'),
                    }" v-model="dataPermohonan.garis_pantai" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Garis Pantai')">
                      {{ errors.first("form-1.Garis Pantai") }}
                    </span>
                  </b-form-group>
                </b-col>


                <b-col md="6">
                  <b-form-group label-for="Form" label ="Jenis Permohonan PNBP: *">
                    <v-select disabled  id="default-select" v-model="dataPermohonan.jenis_pnbp" :options="[
                      'Area',
                      'Kabel Bawah Laut',
                      'Pipa Air Bersih / Air Baku',
                      'Pipa Selain Air Bersih / Air Baku',
                    ]" v-validate="'required'" name="Jenis Permohonan PNBP"
                      :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan PNBP') }" @input="handleJenisPNBPChange"
                      :multiple="true" :close-on-select="false" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan PNBP')">
                      {{ errors.first("form-1.Jenis Permohonan PNBP") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="dataPermohonan.jenis_pnbp.includes('Area')">
                  <b-form-group label-for="Form" label ="Luas (ha) *">
                    <b-form-input disabled min="0" step=".01" type="number" name="Luas" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Luas'),
                    }" v-model="dataPermohonan.luas" />
                    <span class="text-danger" v-if="errors.has('form-1.Luas')">
                      {{ errors.first("form-1.Luas") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
                ">
                  <b-form-group label="Panjang Kabel(di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi_kabel" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
                ">
                  <b-form-group label="Panjang Kabel(di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi_kabel" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Kabel(di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') 
                ">
                  <b-form-group label="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input disabled min="0" step=".01" type="number" name="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi_pipa_air" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') 
                ">
                  <b-form-group label="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input disabled min="0" step=".01" type="number" name="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_air" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
                ">
                  <b-form-group label="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input disabled min="0" step=".01" type="number" name="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi_pipa_lain" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
                ">
                  <b-form-group label="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input disabled min="0" step=".01" type="number" name="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_lain" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label-for="Form" label ="Kedalaman (m) *">
                    <b-form-input disabled v-validate="'required'" name="Kedalaman" min="0" step=".01" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Kedalaman'),
                    }" v-model="dataPermohonan.kedalaman" type="number" />
                    <span class="text-danger" v-if="errors.has('form-1.Kedalaman')">
                      {{ errors.first("form-1.Kedalaman") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label-for="Form" label ="Rencana Detail Kegiatan: *">
                      <b-form-textarea disabled v-model="dataPermohonan.rencana_detail_kegiatan"
                        placeholder="Masukkan Rencana Detail Kegiatan">

                      </b-form-textarea>
                      <!-- <ckeditor
                        :editor="wygEditor"
                        v-model="dataPermohonan.rencana_detail_kegiatan"
                      ></ckeditor> -->
                    </b-form-group>
                  </div>
                </b-col>

                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label-for="Form" label ="Hasil Penilaian Teknis: *">
                      <ckeditor disabled :editor="wygEditor" v-model="dataPermohonan.hasil_verifikasi_teknis"></ckeditor>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label-for="Form" label ="Catatan: *">
                      <ckeditor disabled :editor="wygEditor" v-model="dataPermohonan.catatan_vertek"></ckeditor>
                    </b-form-group>
                  </div>
                </b-col>

              </b-row>

            </b-form>
            <div class="row justify-content-between">
                <div class="col-4">
                    <div class="text-left">
                        <b-button @click="previousDokumen()" variant="primary" ><i class="fa fa-caret-left" /> Sebelumnya</b-button>
                    </div>
                </div>
                <div class="col-4">
                    <div class="text-right">
                        <b-button @click="nextDokumen()" style="float:right" variant="primary" >Selanjutnya <i class="fa fa-caret-right" /></b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    data() {
        return {

        }
    },
    components: { vSelect },
    props: {
        dataPermohonan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKlasifikasi: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataProvinsi: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKabupaten: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataJenisPermohonan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKecamatan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        wygEditor: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    methods: {
        finishDokumen() {
            this.$emit('finishDokumen')
        },

        previousDokumen(){
            this.$emit('previousDokumen')
        },

        nextDokumen(){
            this.$emit('nextDokumen')
        },

        getKabupaten(data){
            this.$emit('getKabupaten', data)
        },

        getKecamatan(data){
            this.$emit('getKecamatan', data)
        }

    }
}
</script>